import ConfirmationModal from './ConfirmationModal';
export default ConfirmationModal;
//# sourceMappingURL=index.js.map